module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAPCAYAAAACsSQRAAAACXBIWXMAAAsSAAALEgHS3X78AAAAnUlEQVQ4T2NgwAL+///PBcSHgFgRmzy6GBO6AFAjM1BsFRAfZmRkvE+MIRhqgIbMAeIFQMxIrgENQM07gZiNXAOSgZrPAjEPuQZ4ATXfBmJxcg0wBWp+CMRqZBkA1MQI1HwNSLMCsSi5hjAADaHYJWDLgQZRFiYwLwANoix2kAwCpZMdZKcTJIMoS7HQ8GEGumQLELeSHVtQg0jKxQCy/I1A5e0YMgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/ButtonSquare/assets/img/back_button_icon.png
// module id = 553
// module chunks = 168707334958949